import { BaseSyntheticEvent, Dispatch, SetStateAction } from 'react';

import { preventDefaults } from '../prevent-defaults/prevent-defaults.util';

export const handleDragEvent = (
  setDragOver: Dispatch<SetStateAction<boolean>>,
  dragOver: boolean
): ((event: BaseSyntheticEvent) => void) => {
  return (event: BaseSyntheticEvent): void => {
    preventDefaults(event);
    setDragOver(dragOver);
  };
};
